import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7505f06c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "contact_section_title" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "contact_title" }, "let us know"),
  /*#__PURE__*/_createElementVNode("div", { id: "contact_caption" }, "if you have any questions or feedback")
], -1))
const _hoisted_3 = { class: "contact_section_form" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact_form_title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Contact us directly:")
], -1))
const _hoisted_5 = { class: "contact_form_container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "contact_form_left" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Have any questions about the club?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Reach out to us on Facebook, Instagram, or at "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:president@ubcjazzclub.ca" }, "president@ubcjazzclub.ca"),
    /*#__PURE__*/_createTextVNode("! ")
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "Link to socials below!")
], -1))
const _hoisted_7 = { id: "contact_form_right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Interested in booking our band?", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Please email us at "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:music@ubcjazzclub.ca" }, "music@ubcjazzclub.ca"),
  /*#__PURE__*/_createTextVNode(" to book a gig! ")
], -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("p", null, _toDisplayString(_ctx.bookingDesc), 1),
          _hoisted_10,
          _createElementVNode("p", null, _toDisplayString(_ctx.bookingPolicy), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.compensation), 1),
          _hoisted_11,
          _hoisted_12
        ])
      ])
    ])
  ]))
}